import styled, { css } from 'styled-components'
import { StyledTextProps } from './Text.types'

const variantStyles = {
  h1: css`
    font-size: ${({ theme }) => theme.typography.fontSize.hero};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.normal};
  `,
  h2: css`
    font-size: ${({ theme }) => theme.typography.fontSize.hero};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.normal};
  `,
  h3: css`
    font-size: ${({ theme }) => theme.typography.fontSize.title};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.normal};
  `,
  h4: css`
    font-size: ${({ theme }) => theme.typography.fontSize.title};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.normal};
  `,
  h5: css`
    font-size: ${({ theme }) => theme.typography.fontSize.section};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.normal};
  `,
  h6: css`
    font-size: ${({ theme }) => theme.typography.fontSize.section};
    font-weight: ${({ theme }) => theme.typography.fontWeight.semibold};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.normal};
  `,
  body1: css`
    font-size: ${({ theme }) => theme.typography.fontSize.body};
    font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
    line-height: ${({ theme }) => theme.typography.lineHeight.normal};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.normal};
  `,
  body2: css`
    font-size: ${({ theme }) => theme.typography.fontSize.small};
    font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
    line-height: ${({ theme }) => theme.typography.lineHeight.normal};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.normal};
  `,
  caption: css`
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
    font-weight: ${({ theme }) => theme.typography.fontWeight.normal};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.uppercase};
  `,
  overline: css`
    font-size: ${({ theme }) => theme.typography.fontSize.micro};
    font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
    line-height: ${({ theme }) => theme.typography.lineHeight.tight};
    letter-spacing: ${({ theme }) => theme.typography.letterSpacing.uppercase};
    text-transform: uppercase;
  `,
}

const colorStyles = {
  primary: css`
    color: ${({ theme }) => theme.colors.text.primary};
  `,
  secondary: css`
    color: ${({ theme }) => theme.colors.text.secondary};
  `,
  disabled: css`
    color: ${({ theme }) => theme.colors.text.tertiary};
  `,
  inverse: css`
    color: ${({ theme }) => theme.colors.text.inverse};
  `,
  success: css`
    color: ${({ theme }) => theme.colors.success};
  `,
  danger: css`
    color: ${({ theme }) => theme.colors.danger};
  `,
  warning: css`
    color: ${({ theme }) => theme.colors.warning};
  `,
  info: css`
    color: ${({ theme }) => theme.colors.primary};
  `,
}

export const StyledText = styled.span<StyledTextProps>`
  font-family: ${({ theme }) => theme.typography.fontFamily.sans};
  margin: 0;

  ${(props) => variantStyles[props.$variant]}
  ${(props) => {
    // Check if color is a predefined color key or custom string
    if (typeof props.$color === 'string' && props.$color in colorStyles) {
      return colorStyles[props.$color as keyof typeof colorStyles]
    }
    // Otherwise use the color as-is
    return css`
      color: ${props.$color};
    `
  }}
  
  font-weight: ${(props) => props.theme.typography.fontWeight[props.$weight]};
  text-align: ${(props) => props.$align};

  ${(props) =>
    props.$italic &&
    css`
      font-style: italic;
    `}

  ${(props) =>
    props.$underline &&
    css`
      text-decoration: underline;
    `}
  
  ${(props) =>
    props.$truncate &&
    css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `}
`
